import type { Variants } from 'motion/react'

export const footerVariants: Variants = {
    hidden: { opacity: 0, y: 20 },
    visible: {
        opacity: 1,
        y: 0,
        transition: {
            type: 'spring',
            damping: 25,
            stiffness: 200,
            delay: 0.4,
            staggerChildren: 0.1,
            when: 'beforeChildren',
        },
    },
}

export const linkVariants: Variants = {
    hidden: { opacity: 0, y: 10 },
    visible: {
        opacity: 1,
        y: 0,
        transition: { type: 'spring', damping: 25, stiffness: 300 },
    },
}
